module.exports = __webpack_public_path__ + "static/linux-original-2bf747f09a4f9135fbd3032432f4158b.svg";